/**
 * Admin User Model
 * 관리자 사용자 도메인 모델
 */

export type AdminRole = 'super_admin' | 'admin' | 'operator';
export type ServiceType = 'studyroom' | 'academy' | 'cafe' | 'gym';

export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: AdminRole;
  phone?: string;
  service_type?: ServiceType;
  is_active: boolean;
  is_suspended: boolean;
  last_login?: string;
  created_at: string;
  updated_at: string;
}

export interface AdminLoginRequest {
  email: string;
  password: string;
}

export interface AdminLoginResponse {
  access_token: string;
  token_type: string;
  admin_user: AdminUser;
}

export interface AdminProfileUpdateRequest {
  name?: string;
  phone?: string;
  email?: string;
}

export interface AdminPasswordChangeRequest {
  current_password: string;
  new_password: string;
}

export interface CreateOperatorRequest {
  email: string;
  password: string;
  name: string;
  phone?: string;
  service_type: ServiceType;
}

export interface UpdateProfileRequest {
  name?: string;
  phone?: string;
}

// Helper functions
export const isSubperAdmin = (user: AdminUser): boolean => {
  return user.role === 'super_admin' || user.role === 'admin';
};

export const isOperator = (user: AdminUser): boolean => {
  return user.role === 'operator';
};

export const canManageServiceType = (
  user: AdminUser,
  serviceType: ServiceType
): boolean => {
  if (isSubperAdmin(user)) return true;
  return user.service_type === serviceType;
};

export const getRoleDisplayName = (role: AdminRole): string => {
  const roleNames: Record<AdminRole, string> = {
    super_admin: '슈퍼 관리자',
    admin: '관리자',
    operator: '운영자',
  };
  return roleNames[role];
};

export const getServiceDisplayName = (serviceType?: ServiceType): string => {
  if (!serviceType) return '전체';

  const serviceNames: Record<ServiceType, string> = {
    studyroom: '독서실',
    academy: '학원',
    cafe: '카페',
    gym: '헬스장',
  };
  return serviceNames[serviceType];
};
